import {Actions} from '../constants/permissions/actions';
import {Permissions} from '../constants/permissions/permissions';
import {Roles, TeamRoles} from '../constants/roles';

export function can(action: Actions, roles: (Roles | TeamRoles)[]) {
  return (
    Permissions[action]?.some((allowedRole) => roles.includes(allowedRole)) ??
    false
  );
}
